(function () {
  const SELECTOR_SECTION = '[data-brewing-guide]';
  const SELECTOR_METHOD = '[data-brewing-method]';
  const SELECTOR_METHOD_TAB = '[data-brewing-method-tab]';
  const SELECTOR_TAB = '[data-brewing-tab]';
  const SELECTOR_PANEL = '[data-brewing-panel]';
  const SELECTOR_IMAGE = '[data-brewing-image]';

  /**
   * 煎タブの切り替え。
   *
   * scope は必ず個別の淹れ方（method）要素であること。セクション全体を渡すと、
   * 複数の淹れ方が並んだときに他の淹れ方のタブまで巻き込んで切り替わる。
   * （2026-08-03 の複数method対応より前は、1商品=1淹れ方の前提でセクション全体を
   *   スコープにしていた。複数MO描画に変えた時点でこの前提は崩れている）
   */
  function activate(scope, idx) {
    const tabs = Array.from(scope.querySelectorAll(SELECTOR_TAB));
    const panels = Array.from(scope.querySelectorAll(SELECTOR_PANEL));

    tabs.forEach((t) => {
      const active = t.dataset.brewingTab === idx;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach((p) => {
      const active = p.dataset.brewingPanel === idx;
      p.classList.toggle('is-active', active);
      if (active) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  /** 左カラムの画像を、開いている淹れ方のものに差し替える。 */
  function showImage(section, methodIndex) {
    const slots = Array.from(section.querySelectorAll(SELECTOR_IMAGE));
    if (!slots.length) return; // MO側に画像が無くセクション共通画像を出しているケース
    slots.forEach((el) => {
      const active = el.dataset.brewingImage === methodIndex;
      el.classList.toggle('is-active', active);
      if (active) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest(SELECTOR_TAB);
    if (!tab) return;
    const scope = tab.closest(SELECTOR_METHOD);
    if (!scope) return;
    activate(scope, tab.dataset.brewingTab);
  });

  // Arrow key navigation within a tablist (left/right move focus + activate).
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const tab = event.target.closest(SELECTOR_TAB);
    if (!tab) return;
    const scope = tab.closest(SELECTOR_METHOD);
    if (!scope) return;

    const tabs = Array.from(scope.querySelectorAll(SELECTOR_TAB));
    const currentIdx = tabs.indexOf(tab);
    if (currentIdx < 0) return;

    event.preventDefault();
    const dir = event.key === 'ArrowRight' ? 1 : -1;
    const next = tabs[(currentIdx + dir + tabs.length) % tabs.length];
    activate(scope, next.dataset.brewingTab);
    next.focus();
  });

  /**
   * 淹れ方（method）の切り替え。セグメンテッドコントロールのピルを押したとき。
   *
   * - 押された淹れ方のパネルだけを出す
   * - 左カラムの画像をその淹れ方のものへ差し替える
   * - 煎タブを一煎目へ戻す
   *   （三煎目を選んだまま単煎の水出しへ切り替えると、存在しないパネルを指してしまう）
   */
  function selectMethod(section, mi) {
    section.querySelectorAll(SELECTOR_METHOD_TAB).forEach((btn) => {
      const active = btn.dataset.brewingMethodTab === mi;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      btn.setAttribute('tabindex', active ? '0' : '-1');
    });

    section.querySelectorAll(SELECTOR_METHOD).forEach((panel) => {
      const active = panel.dataset.brewingMethod === mi;
      if (active) {
        panel.removeAttribute('hidden');
        activate(panel, '0');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    showImage(section, mi);
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest(SELECTOR_METHOD_TAB);
    if (!btn) return;
    const section = btn.closest(SELECTOR_SECTION);
    if (!section) return;
    selectMethod(section, btn.dataset.brewingMethodTab);
  });

  // 淹れ方ピルも矢印キーで移動できるようにする（煎タブと同じ操作感）
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const btn = event.target.closest(SELECTOR_METHOD_TAB);
    if (!btn) return;
    const section = btn.closest(SELECTOR_SECTION);
    if (!section) return;

    const btns = Array.from(section.querySelectorAll(SELECTOR_METHOD_TAB));
    const idx = btns.indexOf(btn);
    if (idx < 0) return;

    event.preventDefault();
    const dir = event.key === 'ArrowRight' ? 1 : -1;
    const next = btns[(idx + dir + btns.length) % btns.length];
    selectMethod(section, next.dataset.brewingMethodTab);
    next.focus();
  });
})();
